import React, {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import {useCurrentUser, useLoggedIn, useCitepayUser, useShowPasswordDialog} from "../context/contextHooks";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom"
import Typography from "@mui/material/Typography";
import {useSxStyles as sx} from "../styles/sxStyles";



export default function MainMenu() {
    const location = useLocation();
    const [isLoggedIn, setIsLoggedIn] = useLoggedIn();
    const [currentUser] = useCurrentUser();
    const citepayUser = useCitepayUser();
    const [currentMenuState, setCurrentMenuState] = useState('searchBalances');
    const [, setShowPasswordDialog] = useShowPasswordDialog()

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        setCurrentMenuState(currentMenuState);
    }, [currentMenuState]);

    const onClickManageUsers = () => {
        setCurrentMenuState('manageUsers');
        handleClose();
    }

    const onClickSearchBalances = () => {
        setCurrentMenuState('searchBalances');
        handleClose();
    }

    const onClickLogging = () => {
        setCurrentMenuState('logging');
        handleClose();
    }

    const onClickLogout = () => {
       setIsLoggedIn(false);
    }

    const onClickChangePassword = () => {
        setShowPasswordDialog(true);
        handleClose();
    }

    function MainMenuItems() {
        if (location.pathname === '/users' && isLoggedIn && currentUser.isAdmin) {
            setCurrentMenuState('manageUsers');
            return (
                <>
                    <div>
                        <Link to={{pathname: `/lookup/`}}><MenuItem onClick={onClickSearchBalances}
                                                                    sx={sx.menuText}>Pay Balances</MenuItem></Link>
                    </div>
                    { currentUser.agencyId &&
                        <div>
                            <Link to={{pathname: `/logging/`}}><MenuItem onClick={onClickLogging}
                                                                         sx={sx.menuText}>Call Logging</MenuItem></Link>
                        </div>
                    }
                </>
            )
        } else if (location.pathname === '/miscFees') {
            return (
                <>
                    <div>
                        {currentUser.isAdmin &&
                            <Link to={{pathname: `/users/`}}><MenuItem onClick={onClickManageUsers} sx={sx.menuText}>Manage Users</MenuItem></Link>
                        }
                    </div>
                </>
            )
        } else if (currentMenuState === 'searchBalances' && isLoggedIn && (currentUser.isAdmin || citepayUser)) {
            return (
                <>
                    <div>
                        <Link to={{pathname: `/users/`}}><MenuItem onClick={onClickManageUsers} sx={sx.menuText}>Manage Users</MenuItem></Link>
                    </div>
                    { currentUser.agencyId &&
                        <div>
                            <Link to={{pathname: `/logging/`}}><MenuItem onClick={onClickLogging}
                                                                         sx={sx.menuText}>Call Logging</MenuItem></Link>
                        </div>
                    }
                </>
            )
        } else if (currentMenuState === 'manageUsers' && isLoggedIn && !citepayUser) {
            return (
                <>
                    <div>
                        <Link to={{pathname: `/lookup/`}}><MenuItem onClick={onClickSearchBalances} sx={sx.menuText}>Pay
                            Balances</MenuItem></Link>
                    </div>
                    {currentUser.agencyId &&
                        <div>
                            <Link to={{pathname: `/logging/`}}><MenuItem onClick={onClickLogging}
                                                                         sx={sx.menuText}>Call Logging</MenuItem></Link>
                        </div>
                    }
                </>
            )
        } else if (currentMenuState === 'logging' && isLoggedIn && !citepayUser) {
            return (
                <>
                    <div>
                        <Link to={{pathname: `/lookup/`}}><MenuItem onClick={onClickSearchBalances}
                                                                    sx={sx.menuText}>Pay Balances</MenuItem></Link>
                    </div>
                    { currentUser.isAdmin &&
                        <div>
                            <Link to={{pathname: `/users/`}}><MenuItem onClick={onClickManageUsers} sx={sx.menuText}>Manage Users</MenuItem></Link>
                        </div>
                    }
                </>
            )
        } else {
            return (<></>)
        }
    }

        return (
            (<div>
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    aria-controls="fade-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    size="large">
                    <MenuIcon/>
                    <Typography variant="caption" sx={sx.user}>{currentUser.username}</Typography>
                </IconButton>
                <Menu
                    id="fade-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                    on={'true'}
                    slots={{
                        transition: Fade
                    }}
                >
                    <MainMenuItems/>
                    <Divider sx={sx.menuTextDivider}/>
                    <MenuItem onClick={onClickChangePassword} sx={sx.menuText}>Change Password</MenuItem>
                    <Divider sx={sx.menuTextDivider}/>
                    {/*
                    <MenuItem onClick={() => setIsLoggedIn(false)} sx=sx.menuText>Logout</MenuItem>
                    */}
                    <Link to={{pathname: `/`}}><MenuItem onClick={onClickLogout} sx={sx.menuText}>Logout</MenuItem></Link>
                </Menu>
            </div>)
        );
}

